import React from 'react';
import { useState } from 'react';
import { generateDate, getEmailText } from '../../../utils/utils';

import {Button} from 'material-ui'
import trash from '../../../assets/img/trash.svg'
import fileImg from '../../../assets/img/file.svg'
import close from '../../../assets/img/close.svg'
import FontAwesomeIcon from "@fortawesome/react-fontawesome"
import { faSpinner } from '@fortawesome/fontawesome-free-solid'

import "./pop-up.scss"
import { useDispatch } from 'react-redux';
import { showMessage } from 'modules/messages/actions';
import { emailSuccessMessage, failedMessage } from 'service/constants';
import { sendEmailInvoice } from 'service/api';

const EmailPopUp = ({closeHandler, email, name, file, text, updateText, textLoading}) => {
    const dispatch = useDispatch()

    const date = generateDate()
    const fileName = `${date} - ${name}.pdf`
    
    const [loading, setLoading] = useState(false)
    const [emailText, setText] = useState(text)
    const [emailChange, setEmail] = useState(email)
    const [title, setTitle] = useState(`Invoice ${date}`)

    const refreshEmail = (e) => {
        e.preventDefault()
        setEmail('')
    }
    
    const onChange = (e, setState) => {
        setState(e.target.value)
    }

    const updateEmailHandler = () => {
        updateText(emailText)
    }

    const emailHandler = async () => {
        try {
            setLoading(true)
            const emailText = getEmailText(name, date, text)
            await sendEmailInvoice({email, text: emailText, title, file, fileName})
            closeHandler()
            dispatch(showMessage(emailSuccessMessage))
        } catch(e) {
            dispatch(showMessage(failedMessage))
        } finally {
            setLoading(false)
        }
    }

    const isBtnDisabled = !emailChange || !file || loading

    return (
        <div className='email-pop-up'>
            <form>
                <button 
                    className="icon-button close-button"
                    onClick={closeHandler}
                >
                    <img className="close-button" src={close} alt="close-button"/>
                </button>
                
                <div className='form-wrapper'>
                    <div className="input-wrapper">
                        <span className="input-head">Email</span>
                        <input 
                            value={emailChange} 
                            onChange={e => onChange(e, setEmail)}
                        />
                        <button 
                            className="icon-button delete-btn"
                            onClick={refreshEmail}
                        >
                            <img src={trash} alt=""/>
                        </button>
                    </div>
                    <div className="input-wrapper">
                        <span className="input-head">Title</span>
                        <input 
                            value={title}
                            onChange={e => onChange(e, setTitle)}
                        />
                    </div>
                    <div className="input-wrapper">
                        <div className="textarea-wrapper">
                            Hi {name},<br/><br/>
                            Your {date} invoice is now available. Please find the invoice in the attachment. The pay date is always on the last business day of the month, except special occasions.
                            <br/><br/>
                            <textarea
                                value={emailText}
                                onChange={e => onChange(e, setText)}
                            />
                        </div>
                        <Button 
                            color="secondary" 
                            variant="raised" 
                            className="save-btn"
                            disabled={text === emailText || textLoading}
                            onClick={updateEmailHandler}
                        >
                            { textLoading ? <FontAwesomeIcon icon={faSpinner} spin /> : "Save"}
                        </Button>
                    </div>
                    <div className="file-name">
                        <span className="file-head">FILE</span>
                        <div className="file">
                            <img src={fileImg} alt=""/>
                            <span>{fileName}</span>
                        </div>
                    </div>
                </div>
                <Button 
                    color="secondary" 
                    variant="raised" 
                    className="send-btn"
                    disabled={isBtnDisabled }
                    onClick={emailHandler}
                >
                    { loading ? <FontAwesomeIcon icon={faSpinner} spin /> : "Send"}
                </Button>
            </form>
        </div>
    );
};

export default EmailPopUp;